import { createContext } from "react";

import type { HaNSelection, HereAndNowTab } from "@lib/logic";

type HaNDetailsContextValue = {
  tab: HereAndNowTab;
  selection: HaNSelection;

  // Closes the details, asking first when that would throw away a booking with changes
  close: () => void;
};

// What the details panel shows. While it slides closed this is still the selection it was opened for.
export const HaNDetailsContext = createContext<HaNDetailsContextValue | null>(null);
